import { render } from "./predictive-search.vue?vue&type=template&id=4e810b2b"
import script from "./predictive-search.vue?vue&type=script&lang=js"
export * from "./predictive-search.vue?vue&type=script&lang=js"

import "./predictive-search.vue?vue&type=style&index=0&id=4e810b2b&lang=scss"

import exportComponent from "/Users/machintoshssd/sites/bio-effect-dk-theme/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__